import { unreachable } from '../../../../ts-utils';
import { MARK_COMMENT_FAILURE, MARK_COMMENT_REQUEST, MARK_COMMENT_SUCCESS, } from './mark-actions';
import { isMarkable } from './mark-types';
import { hiddenComponentEffectsGuard } from '../effects/hidden-component-effects-guard';
export function commentsMarkReducer(state, action) {
    switch (action.type) {
        case MARK_COMMENT_REQUEST: {
            const { commentId, subaction } = action.payload;
            const commentState = state.commentsById[commentId];
            if (!isMarkable(commentState)) {
                return state;
            }
            return {
                ...state,
                commentsById: {
                    ...state.commentsById,
                    [commentId]: {
                        ...commentState,
                        marked: { type: 'PENDING', action: subaction },
                    },
                },
            };
        }
        case MARK_COMMENT_FAILURE: {
            const { commentId, error } = action.payload;
            const commentState = state.commentsById[commentId];
            if (!isMarkable(commentState)) {
                return state;
            }
            if (commentState.marked.type !== 'PENDING') {
                return state;
            }
            return {
                ...state,
                commentsById: {
                    ...state.commentsById,
                    [commentId]: {
                        ...commentState,
                        marked: { type: 'IDLE' },
                    },
                },
                ...hiddenComponentEffectsGuard(state, {
                    highlight: { type: 'CRUD_ERROR', id: commentId, timestamp: Date.now() },
                    toast: error.type === 'SILENT'
                        ? state.effects?.toast
                        : { skin: 'error', message: error, timestamp: Date.now() },
                }),
            };
        }
        case MARK_COMMENT_SUCCESS: {
            const { commentId, isMarked } = action.payload;
            const commentState = state.commentsById[commentId];
            if (!isMarkable(commentState)) {
                return state;
            }
            return {
                ...state,
                commentsById: {
                    ...state.commentsById,
                    [commentId]: {
                        ...commentState,
                        marked: { type: 'IDLE' },
                        comment: {
                            ...commentState.comment,
                            isMarked,
                            revisionId: action.payload.revision ?? commentState.comment.revisionId,
                        },
                    },
                },
            };
        }
        default:
            throw unreachable(action);
    }
}
//# sourceMappingURL=mark-reducer.js.map